import { fetchBackend } from "./fetch";



export const getEndDateFromBack = async(body) =>{
    const resp = await fetchBackend('tenant/tenantendtrial',body , 'POST')
    const respJson =  resp.json()
    return respJson
}